<!-- eslint-disable max-len -->
<template>
  <div class="external-api-field">
    <!-- Header -->
    <div class="header-field">
      <div class="d-flex align-items-center">
        <div class="icon-ext-api">
          <img src="@/assets/new-form-ui/icon/script-action.svg">
        </div>
        <h4 class="title-field">Action</h4>
      </div>
      <p
        class="close-modal"
        @click="closeModal"
      >
        &times;
      </p>
    </div>

    <!-- Content -->
    <div class="external-api-content external-api-content--fullscreen">
      <b-row>
        <b-col md="8">
          <div class="configuration-section">
            <h4 class="configuration-section-title">
              Custom Condition
            </h4>
            <b-form>
              <label> Script </label>
              <j-monaco-editor
                v-if="showEditor"
                ref="script"
                :value="dataSetup.script"
                height="calc(90vh - 200px)"
              />
            </b-form>
          </div>
        </b-col>

        <b-col
          md="4"
          class="external-api-content__item"
        >
          <div class="configuration-section">
            <h4 class="configuration-section-title">
              Custom Message confirmation
            </h4>
            <p class="configuration-section-desc">
              Show message confirmation before executing the action
            </p>

            <div class="div-confirmation-message">
              <div
                :class="{'type--active': confirmationMessageType === 'static'}"
                class="type"
                @click="setConfirmationMessageType('static')">
                Static
              </div>
              <div
                :class="{'type--active': confirmationMessageType === 'dynamic'}"
                class="type"
                @click="setConfirmationMessageType('dynamic')">
                Dynamic
              </div>
            </div>

            <b-form
              v-if="dataSetup.is_use_confirmation_message && confirmationMessageType === 'static'"
              :class="{'error-input' : $v.dataSetup.custom_confirmation_message.$error}">
              <label>Static custom message</label>
              <j-input
                v-model="dataSetup.custom_confirmation_message"
                :error-required="false"
                placeholder="Enter static custom confirmation message"/>
            </b-form>

            <b-form
              v-if="dataSetup.is_use_confirmation_message && confirmationMessageType === 'dynamic'"
              :class="{'error-input' : $v.dataSetup.dynamic_confirmation_message.$error}">
              <label>Function dynamic custom message</label>
              <j-single-select
                v-model="dataSetup.dynamic_confirmation_message"
                :options="listFunction"
                :error-required="false"
                placeholder="Select function dynamic custom message"
                label="name"/>
            </b-form>

            <b-form v-if="dataSetup.is_use_confirmation_message && confirmationMessageType === 'dynamic'">
              <label> Params </label>
              <div
                v-for="(data, index) in dataSetup.dynamic_confirmation_message_params"
                :key="index"
                class="form-list">
                <input
                  v-model="data.variable"
                  type="text"
                  placeholder="Variable"
                  class="name" >
                <input
                  v-model="data.value"
                  type="text"
                  placeholder="Value"
                  class="value" >
                <i
                  class="fa fa-trash"
                  @click="deleteParams(index)" />
              </div>
              <div
                class="btn-add-config"
                @click="addParams">
                + Add Params
              </div>
            </b-form>
          </div>

          <div class="configuration-section">
            <h4 class="configuration-section-title">
              Variables
            </h4>
            <b-form>
              <label> Variable Message </label>
              <j-input
                v-model="dataSetup.variable_message"
                :error-required="false"
              />
              <span class="small-text">
                A variable containing a message to be displayed in a modal error.
              </span>
            </b-form>
            <b-form>
              <label> Variable Redirect </label>
              <j-input
                v-model="dataSetup.variable_redirect"
                :error-required="false"
              />
              <span class="small-text">
                Variable containing detailed information for page redirect.
              </span>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Footer -->
    <div class="external-api-footer">
      <button
        class="button-border mr-2"
        @click="closeModal"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="submitForm"
      >
        Set
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len */
import { mapActions, mapState } from 'vuex';
import { requiredIf } from 'vuelidate/lib/validators';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jwtDecode from 'jwt-decode';

export default {
  components: {
    jMonacoEditor,
  },

  mixins: [jMixAutoScroll],

  data() {
    return {
      showEditor: false,
      dataSetup: {
        script: '',
        variable_message: null,
        variable_redirect: '',
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: null,
        dynamic_confirmation_message_params: [],
      },
      confirmationMessageType: null,
      listFunction: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['sourceScriptActionBtn']),
  },

  watch: {
    confirmationMessageType(val) {
      if (val) {
        this.dataSetup.is_use_confirmation_message = true;

        if (val === 'static') {
          this.dataSetup.dynamic_confirmation_message = null;
          this.dataSetup.dynamic_confirmation_message_params = [];
        }
        if (val === 'dynamic') this.dataSetup.custom_confirmation_message = '';
      } else {
        this.dataSetup.is_use_confirmation_message = false;
        this.dataSetup.custom_confirmation_message = '';
        this.dataSetup.dynamic_confirmation_message = null;
        this.dataSetup.dynamic_confirmation_message_params = [];
      }
    },
  },

  created() {
    if (this.sourceScriptActionBtn) {
      this.dataSetup = {
        script: this.sourceScriptActionBtn.script,
        variable_message: this.sourceScriptActionBtn.variable_message,
        variable_redirect: this.sourceScriptActionBtn.variable_redirect,
        is_use_confirmation_message: this.sourceScriptActionBtn.is_use_confirmation_message,
        custom_confirmation_message: this.sourceScriptActionBtn.custom_confirmation_message,
        dynamic_confirmation_message: this.sourceScriptActionBtn.dynamic_confirmation_message || null,
        dynamic_confirmation_message_params: [],
      };
      this.confirmationMessageType = this.sourceScriptActionBtn.dynamic_confirmation_message ? 'dynamic' :
        (this.sourceScriptActionBtn.custom_confirmation_message ? 'static' : null);

      if (this.sourceScriptActionBtn.dynamic_confirmation_message_params) {
        const paramsData = Object.keys(this.sourceScriptActionBtn.dynamic_confirmation_message_params);
        const paramsValueData = Object.values(this.sourceScriptActionBtn.dynamic_confirmation_message_params);
        this.dataSetup.dynamic_confirmation_message_params = paramsData.map((e, index) => ({
          variable: e,
          value: paramsValueData[index],
        }));
      }
    }
    this.getListFunction();

    setTimeout(() => {
      this.showEditor = true;
    }, 200);
  },

  methods: {
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalScriptActionButton']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),

    closeModal() {
      this.toggleModalScriptActionButton({ status: false, data: null });
    },

    submitForm() {
      this.$v.dataSetup.$touch();

      if (!this.$v.dataSetup.$error) {
        const dataParams = {};
        this.dataSetup.dynamic_confirmation_message_params.forEach((element) => {
          if (element.variable && element.value) dataParams[element.variable] = element.value;
        });
        const data = {
          type: 'after',
          script: this.$refs.script.getData(),
          variable_message: this.dataSetup.variable_message,
          variable_redirect: this.dataSetup.variable_redirect,
          is_use_confirmation_message: this.dataSetup.is_use_confirmation_message,
          custom_confirmation_message: this.dataSetup.custom_confirmation_message,
          dynamic_confirmation_message: this.dataSetup.dynamic_confirmation_message,
          dynamic_confirmation_message_params: Object.keys(dataParams).length > 0 ? dataParams : null,
        };

        this.toggleModalScriptActionButton({ status: false, data });
      } else {
        this.scrollToErrorField('error-input');
      }
    },

    setConfirmationMessageType(type) {
      if (!this.confirmationMessageType) {
        this.confirmationMessageType = type;
      } else if (this.confirmationMessageType && this.confirmationMessageType !== type) {
        this.confirmationMessageType = type;
      } else if (this.confirmationMessageType && this.confirmationMessageType === type) {
        this.confirmationMessageType = null;
      }
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    addParams() {
      this.dataSetup.dynamic_confirmation_message_params.push({
        variable: null,
        value: null,
      });
    },

    deleteParams(index) {
      this.dataSetup.dynamic_confirmation_message_params.splice(index, 1);
    },
  },

  validations() {
    return {
      dataSetup: {
        custom_confirmation_message: {
          required: requiredIf(() => this.dataSetup.is_use_confirmation_message && this.confirmationMessageType === 'static'),
        },
        dynamic_confirmation_message: {
          required: requiredIf(() => this.dataSetup.is_use_confirmation_message && this.confirmationMessageType === 'dynamic'),
        },
        dynamic_confirmation_message_params: {
          // required: requiredIf(() => this.dataSetup.is_use_confirmation_message && this.confirmationMessageType === 'dynamic'),
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalScriptActionBtn.vue